module.exports = __webpack_public_path__ + "static/img/member-area2.5a7365bb.png";